export default __webpack_public_path__ + "static/media/bestpicofmecropped.84ef5b00.jpg";